import { gql } from '@apollo/client';

export const TOGGLE_NOTIFICATIONS_READ_STATUS = gql`
  mutation ToggleNotificationsReadStatus($input: ToggleNotificationsInput!) {
    toggleNotificationsReadStatus(input: $input) {
      message
      updatedCount
    }
  }
`;

export const CLEAR_ALL_NOTIFICATIONS = gql`
  mutation ClearAllNotifications {
    clearAllNotifications {
      message
    }
  }
`;

export type ToggleNotificationsReadStatusVariables = {
  input: {
    notificationIds: string[];
  };
};

export type ToggleNotificationsReadStatusData = {
  toggleNotificationsReadStatus: {
    message: string;
    updatedCount: number;
  };
};

export type ClearAllNotificationsData = {
  clearAllNotifications: {
    message: string;
  };
};
